var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewConvWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Create_a_new_message",
    "data-name": "Create a new message",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.564,
    height: 21.543,
    viewBox: "0 0 21.564 21.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 21.564,
    height: 21.543,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M9.427,22.047H5.962A5.866,5.866,0,0,1,.071,17.06,5.951,5.951,0,0,1,0,16.105Q0,12.615,0,9.125A5.865,5.865,0,0,1,4.99,3.236a5.411,5.411,0,0,1,.857-.066q2.212-.009,4.424,0a.789.789,0,0,1,.768.506.72.72,0,0,1-.207.846,1.142,1.142,0,0,1-.6.211c-1.433.018-2.867.007-4.3.01A4.308,4.308,0,0,0,1.577,9.06q-.008,3.54,0,7.078a4.3,4.3,0,0,0,4.338,4.334q3.526.006,7.053,0a4.3,4.3,0,0,0,4.339-4.333c.005-1.458,0-2.917,0-4.374a.748.748,0,0,1,.472-.739.688.688,0,0,1,.836.148.943.943,0,0,1,.252.558c.018,1.581.054,3.163,0,4.743a5.847,5.847,0,0,1-5.726,5.566c-1.237.018-2.474,0-3.711,0Z",
    transform: "translate(0 -0.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M23.048,2.508a2.627,2.627,0,0,1-.826,1.884c-1.085,1.082-2.162,2.17-3.243,3.255-1.695,1.7-3.385,3.4-5.09,5.092a1.452,1.452,0,0,1-.646.359c-.968.239-1.945.446-2.92.658a.818.818,0,0,1-1.035-1.028c.219-1,.429-2,.668-2.993a1.255,1.255,0,0,1,.313-.565Q14.447,4.975,18.644.8a2.492,2.492,0,0,1,2.595-.68,2.394,2.394,0,0,1,1.75,1.9,4.676,4.676,0,0,1,.06.487M11.067,11.959c.52-.117,1.007-.212,1.486-.341a1.121,1.121,0,0,0,.474-.263c.8-.784,1.592-1.582,2.385-2.376q2.833-2.832,5.666-5.663a1.085,1.085,0,0,0,.368-.673.914.914,0,0,0-.518-.947,1,1,0,0,0-1.15.223q-4.1,4.079-8.2,8.166a.542.542,0,0,0-.146.245c-.124.525-.236,1.053-.363,1.628",
    transform: "translate(-1.484 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConvWhiteIcon);
export default __webpack_public_path__ + "static/media/new-conv-white-icon.c9dd365075b5ca8cd29cdc7823b77222.svg";
export { ForwardRef as ReactComponent };